module.exports = __webpack_public_path__ + "img/emitHairstyleeditor05.f8aae6c4.png";